import React, { memo, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import ReactECharts from "echarts-for-react";
import { formatNumber, getShortenMark, priceToNumber, shortenNumberAutoK } from "../../helpers/utils";
import * as echarts from "echarts";

const colorMap = [{}];

export default memo(
  function MDDetailChart(props) {
    const refChart = useRef(null);
    //
    const { code, floorPrice, refPrice, ceilPrice } = props;

    const { t } = useTranslation();
    const language = useSelector((state) => state.gShared.language);
    const c_counter = useSelector((state) => state.gSymbol.symbolPriceChart[code]?.counter);
    const c_chartDatas = useSelector((state) => state.gSymbol.symbolPriceChart[code]?.datas);

    const handleDetailsColor = (price) => {
      if (price >= ceilPrice) {
        return "#FF00FF";
      } else if (price <= floorPrice) {
        return "#00CCCC";
      } else if (price > refPrice) {
        return "#00F100";
      } else if (price < refPrice) {
        return "#F10000";
      } else if (price === refPrice) {
        return "#FFD500";
      }
      return "";
    };
    //
    const getOptions = () => {
      let dataKL = [];
      let dataMG = [];
      //
      if (c_chartDatas && c_chartDatas.length > 0) {
        const sortedChartDatas = c_chartDatas.sort((a, b) => (a.price < b.price ? -1 : 1));
        for (let index = 0; index < sortedChartDatas.length; index++) {
          dataKL.push(sortedChartDatas[index].price);
          dataMG.push(sortedChartDatas[index].quantity);
        }
      }
      return {
        useUTC: false,
        textStyle: {
          fontFamily: "tahoma, 'Be Vietnam Pro'",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          textStyle: {
            // lineHeight: 30,
            color: "#fff",
            fontSize: 12,
            lineHeight: "21px",
          },
          padding: [5, 9],
          backgroundColor: "rgba(47, 62, 76, 0.9)",
          borderColor: "transparent",
          confine: true,
          formatter: function (params) {
            let rez = "<p>" + t("mucGia") + ": " + shortenNumberAutoK(params[0].data.xData / 1000, null, { showMark: false }) + "</p>";
            params.forEach((item) => {
              var xx =
                '<p class="chart-tooltip-row">' +
                item.marker +
                "<span>" +
                item.seriesName +
                ":</span>" +
                '<b class="text-right">' +
                formatNumber(item.data.value) +
                "</b></p>";
              rez += xx;
            });
            return rez;
          },
        },
        xAxis: {
          type: "category",
          axisLabel: {
            hideOverlap: true,
            formatter: function (value) {
              return (value / 1000).toFixed(2);
            },
          },
          axisLine: {
            onZero: false,
          },
          splitLine: {
            lineStyle: {
              color: "#666",
            },
          },
          data: dataKL,
        },
        yAxis: [
          {
            // name: t("mucGia"),
            type: "value",
            position: "bottom",
            axisLabel: {
              formatter: function (value) {
                return shortenNumberAutoK(value, null, { showMark: false, maximumFractionDigits: 1 }) + getShortenMark(value, language);
              },
            },
            splitLine: {
              lineStyle: {
                color: "#666",
              },
            },
          },
        ],
        series: [
          {
            yAxisIndex: 0,
            name: t("tongKL"),
            type: "bar",
            itemStyle: {
              color: "#1c4b91",
            },
            barMaxWidth: 45,
            data: dataMG.map((item, key) => ({
              value: item,
              itemStyle: {
                color: handleDetailsColor(dataKL[key]),
                opacity: 0.5,
                 // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  //   {
                  //     offset: 0,
                  //     color: "rgba(158,113,113)",
                  //   },
                  //   {
                  //     offset: 1,
                  //     color: "rgba(241,0,0)",
                  //   },
                  // ]),
              },
              xData:dataKL[key]
            })),
            barCategoryGap: 0,
          },
        ],
        grid: {
          left: "10px",
          right: "10px",
          top: "20px",
          bottom: "10px",
          containLabel: true,
        },
      };
    };

    useEffect(() => {
      if (refChart && refChart.current) {
        refChart.current.getEchartsInstance().setOption(getOptions());
      }
    });

    //
    return (
      <>
        {c_chartDatas && c_chartDatas.length > 0 ? (
          <ReactECharts style={{ ...props.style }} ref={refChart} lazyUpdate={true} option={getOptions()} />
        ) : (
          <></>
        )}
      </>
    );
  },
  (prevProps, nextProps) => {
    if (
      prevProps.code === nextProps.code &&
      prevProps.floorPrice === nextProps.floorPrice &&
      prevProps.refPrice === nextProps.refPrice &&
      prevProps.ceilPrice === nextProps.ceilPrice
    ) {
      return true; // props are equal
    }
    return false; // props are not equal -> update the component
  }
);
